export default function Cta() {
  return (
    <section className="bg-background-50 px-4 pb-12 md:px-6 md:pb-16">
      <div className="mx-auto w-full max-w-7xl">
        <div className="relative overflow-hidden rounded-3xl bg-foreground-950 px-6 py-12 text-center md:px-10 md:py-16">
          <div
            className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-20"
            style={{
              backgroundImage:
                "url(https://readdy.ai/api/search-image?query=warm%20bokeh%20light%20particles%20in%20deep%20charcoal%20with%20subtle%20coral%20and%20gold%20glow%2C%20abstract%20stage%20atmosphere%2C%20dark%20editorial%20background%2C%20no%20text&width=1600&height=500&seq=chigua-cta-2026&orientation=landscape)",
            }}
            aria-hidden="true"
          ></div>
          <div className="relative mx-auto max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
              <i className="ri-flashlight-fill" aria-hidden="true"></i>
              现在就去围观
            </span>
            <h2 className="font-heading mt-4 text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              别让热点从指尖溜走，出发吧
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-200 md:text-base">
              从这一页出发，直达你想围观的现场。记得多平台交叉核对，做个理性又尽兴的围观者。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="#jieru"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-[15px] font-semibold text-foreground-950 transition-colors hover:bg-accent-400 sm:w-auto"
              >
                <i className="ri-compass-3-line text-lg" aria-hidden="true"></i>
                前往直达入口
              </a>
              <a
                href="#faq"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300/60 px-6 py-3 text-[15px] font-medium text-background-50 transition-colors hover:bg-background-900/40 sm:w-auto"
              >
                先看使用说明
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}